import { render, staticRenderFns } from "./orderItemNotesPopover.vue?vue&type=template&id=bd281678&"
import script from "./orderItemNotesPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemNotesPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports